import { render, staticRenderFns } from "./PasswordChangeDialog.vue?vue&type=template&id=013e36e8&scoped=true"
import script from "./PasswordChangeDialog.vue?vue&type=script&lang=js"
export * from "./PasswordChangeDialog.vue?vue&type=script&lang=js"
import style0 from "./PasswordChangeDialog.vue?vue&type=style&index=0&id=013e36e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013e36e8",
  null
  
)

export default component.exports